import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { type IPlanType } from "./types";
import { logger } from "@/core";

const initialState: IPlanType = {
  planType: "studentPlan",
  pendingUpgrade: null,
  checkoutSource: null,
};

const planTypeSlice = createSlice({
  name: "planType",
  initialState,
  reducers: {
    setPlanType: (state, action: PayloadAction<IPlanType>) => {
      state.planType = action.payload.planType;
      // state.planPrice = action.payload.planPrice;
      // state.discountedPlanPrice = action.payload.discountedPlanPrice;
    },
    resetPlanType: (state) => {
      state.planType = null;
      // state.planPrice = null;
      // state.discountedPlanPrice = null;
    },
    // NEW: For new purchase flow from verifyToken
    initiateNewPurchase: (
      state,
      action: PayloadAction<{ planType: "studentPlan" | "teacherPlan" }>,
    ) => {
      logger.info("action", action);
      state.checkoutSource = "verifyToken";
      state.pendingUpgrade = null;
      // Don't change actual planType yet
    },
    initiatePlanUpgrade: (
      state,
      action: PayloadAction<{ targetPlan: "teacherPlan" }>,
    ) => {
      state.pendingUpgrade = action.payload.targetPlan;
      state.checkoutSource = "courses";
    },
    // NEW: Complete checkout (call this after successful payment)
    completeTeacherPlanPurchased: (
      state,
      action: PayloadAction<{ planType?: "studentPlan" | "teacherPlan" }>,
    ) => {
      // Use provided planType, fallback to pendingUpgrade, or default to teacherPlan
      state.planType =
        action.payload.planType || state.pendingUpgrade || "teacherPlan";

      // Clear checkout state
      state.pendingUpgrade = null;
      state.checkoutSource = null;
    },

    // NEW: Cancel checkout (user cancels payment)
    cancelCheckout: (state) => {
      // Keep original planType, just clear checkout state
      state.pendingUpgrade = null;
      state.checkoutSource = null;
    },
  },
});

// Export actions
export const {
  setPlanType,
  resetPlanType,
  initiateNewPurchase,
  initiatePlanUpgrade,
  completeTeacherPlanPurchased,
  cancelCheckout,
} = planTypeSlice.actions;
export default planTypeSlice.reducer;
